import * as mapboxgl from 'mapbox-gl';
import { GeometricFormTypeEnum } from 'src/app/geometrics-form/state/geometric-form.type';

export function featureToSvg(feature: mapboxgl.MapboxGeoJSONFeature): string {
  const icon = createIcon(feature);
  return `<svg width="20px" height="20px" opacity="0.7">
            ${icon}
          </svg>`;
}


function createIcon(feature: mapboxgl.MapboxGeoJSONFeature) {
  if (isVertex(feature)) {
    return `<circle cy="10" cx="10" fill="#000000" r="8" />`;
  }
  if (isBuilding(feature)) {
    return `<line x1="0" y1="10" x2="20" y2="10" stroke="#000000" stroke-width="20" />`;
  }
}


function isVertex(f: mapboxgl.MapboxGeoJSONFeature) {
  return f.layer.id === GeometricFormTypeEnum.VERTEX;
}

function isBuilding(f: mapboxgl.MapboxGeoJSONFeature) {
  return f.layer.id === GeometricFormTypeEnum.BUILDING;
}
